// Author Eric
// Date 2021-05-11 11:42:30

class SithMesPrdOperationStorage {
constructor({
        id = null,
        prdOperationId = '',
        prdOperationName = '',
        mstStorageId = '',
        mstStorageName = ''}
= {}) {
    this.id = id;
    this.prdOperationId = prdOperationId;
    this.prdOperationName = prdOperationName;
    this.mstStorageId = mstStorageId;
    this.mstStorageName = mstStorageName;
}
}

function newEntity() {
return new SithMesPrdOperationStorage();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdOperationStorage.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'orderCode',
        label: 'label.sith.prd.sithMesPrdOperationStorage.grid.orderCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'prdOperationName',
        label: 'label.sith.prd.sithMesPrdOperationStorage.grid.prdOperationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstStorageName',
        label: 'label.sith.prd.sithMesPrdOperationStorage.grid.mstStorageName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    prdOperationIdFilter : "",
    prdOperationNameFilter : "",
    mstStorageIdFilter : "",
    mstStorageNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'prdOperationNameFilter',
        label: 'label.sith.prd.sithMesPrdOperationStorage.filter.prdOperationName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"prdOperationId":"id"}'
                }
        },
        {
        key: 'mstStorageNameFilter',
        label: 'label.sith.prd.sithMesPrdOperationStorage.filter.mstStorageName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocalStorage'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstStorageId":"id"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'prdOperationName',
        label: 'label.sith.prd.sithMesPrdOperationStorage.entity.prdOperationName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'operationSeq'
            ,fieldsBindingByEntityModalSelected: '{"prdOperationId":"id"}'
                }
        },
        {
        key: 'mstStorageName',
        label: 'label.sith.prd.sithMesPrdOperationStorage.entity.mstStorageName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocalStorage'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"mstStorageId":"id"}'
                }
        }
]

export {SithMesPrdOperationStorage, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
